import { BillingPlanTier } from '@core/billing-types';
import type { IconToken } from '@core/user-interface-legacy';

export const billingPlanTokenRecord: Record<BillingPlanTier, IconToken> = {
  [BillingPlanTier.Launch]: 'colorIconPrimaryDefault',
  [BillingPlanTier.Scale]: 'colorIconScaleDefault',
  [BillingPlanTier.Lead]: 'colorIconLeadDefault',
  [BillingPlanTier.Start]: 'colorIconPrimaryDefault',
  [BillingPlanTier.Grow]: 'colorIconScaleDefault',
  [BillingPlanTier.Optimize]: 'colorIconLeadDefault',
};
